var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"body-2 content-field",domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.tooltip)?_c('tooltip',{attrs:{"text":_vm.tooltip}}):_vm._e(),(_vm.helpContent)?_c('helpIcon',{attrs:{"content":_vm.helpContent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }